import { render, staticRenderFns } from "./VerifikasiLoginLinkSendView.vue?vue&type=template&id=0c98256e&scoped=true"
import script from "./VerifikasiLoginLinkSendView.vue?vue&type=script&lang=js"
export * from "./VerifikasiLoginLinkSendView.vue?vue&type=script&lang=js"
import style0 from "./VerifikasiLoginLinkSendView.vue?vue&type=style&index=0&id=0c98256e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98256e",
  null
  
)

export default component.exports